import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface ModalContextType<A = any> {
  active: boolean;
  setActive: Dispatch<SetStateAction<boolean>>;
  modalType:
    | 'ModelVersionSelectModal'
    | 'Modal'
    | 'SaveSearchFiltersGroupModal'
    | 'Popup'
    | 'info'
    | 'MarketingYearsSelectModal';
  setModalType: Dispatch<SetStateAction<ModalContextType<A>['modalType']>>;
  modalProps?: A;
  setModalProps: Dispatch<SetStateAction<A>>;
  setModal: <P extends A>(p: { type: ModalContextType<A>['modalType']; props: P }) => void;
  children: ReactNode[] | ReactNode;
}

export const ModalContext = createContext<
  Pick<ModalContextType, 'setModal' | 'active' | 'setActive' | 'modalType' | 'modalProps'>
>({
  setModal: function (): void {},
  setActive: function (): void {},
  active: false,
  modalType: 'Modal',
});

export const ModalProvider = <A extends Record<string, string>>({
  children,
}: Partial<ModalContextType<A>>): JSX.Element => {
  const [active, setActive] = useState<boolean>(false);
  const [modalType, setModalType] = useState<ModalContextType<A>['modalType']>('Modal');
  const [modalProps, setModalProps] = useState<unknown>();
  const setModal: (p: { type: ModalContextType<A>['modalType']; props: unknown }) => void = ({ type, props }) => {
    setModalType(type);
    setModalProps(props);
    setActive(true);
  };

  return (
    <ModalContext.Provider value={{ setActive, active, setModal, modalType, modalProps }}>
      <>{children}</>
    </ModalContext.Provider>
  );
};
